var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart',{attrs:{"title":"Active Users","apiData":_vm.all},on:{"filtersChanged":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }